<template>

	<table class='table-lpo-list'>
		<thead>
			<tr>
				<th><journal-filter text='Федеральный округ' column='fo'/></th>
				<th><journal-filter text='Субъект РФ' column='region'/></th>
				<th><journal-filter text='Лесничество' column='forestry'/></th>
				<th><journal-filter text='Участковое' column='localforestry'/></th>
				<th><journal-filter text='Урочище/Дача' column='subforestry'/></th>
				<th><journal-filter text='Квартал' column='area'/></th>
				<th><journal-filter text='Выдел' column='section'/></th>
				<th><journal-filter text='ЛП выдел' column='section_lp'/></th>
				<th><journal-filter text='Способ ЛПО' column='inspection_type'/></th>
				<th><journal-filter text='Дата' column='inspection_date'/></th>
			</tr>
		</thead>
		<tbody>
<!-- 			<tr
				v-for='(lpo, i) in lpoList'
				:key='lpo.lpo_id'
				@click='selectLpo(lpo)'
				@dblclick='goToLpo(lpo)'
				:class='{ selected: lpoIsSelected(lpo), "in-group": lpoInGroup(lpo) }'
			> -->
			<tr
				v-for='(lpo, i) in lpoList'
				:key='lpo.lpo_id'
				@click='selectLpo(lpo)'
				@dblclick='goToAct(lpo)'
				:class='{ selected: lpoIsSelected(lpo), "in-group": lpoInGroup(lpo) }'
			>


				<td>{{ lpo.fo }}</td>
				<td>{{ lpo.region }}</td>
				<td>{{ lpo.forestry }}</td>
				<td>{{ lpo.localforestry }}</td>
				<td>{{ lpo.subforestry }}</td>
				<td>{{ lpo.area }}</td>
				<td>{{ lpo.section }}</td>
				<td>{{ lpo.section_lp }}</td>
				<td>{{ lpo.inspection_type }}</td>
				<td>{{ normalizeDate(lpo) }}</td>
			</tr>
		</tbody>
	</table>

</template>

<script>
	import { mapState } from 'vuex';
	import JournalFilter from './JournalLpo__filter';

	export default {
		name: 'JournalLpo__table',

		components: {
			JournalFilter,
		},

		computed: {
			...mapState('journalLpo', {
				selectedLpo: state => state.selectedJournalLpo,
				lpoList: state => state.lpoList
			})
		},
		methods: {
			selectLpo(lpo) {
				this.$store.dispatch('journalLpo/selectJournalLpo', lpo);
			},

			goToAct(lpo) {
				const route_obj = {
					name: 'lpo',
					params: {
						act_id: lpo.lease_id,
						lpo_id: lpo.lpo_id
					}
				};

				this.$router.push(route_obj);
			},

			goToLpo(lpo) {
				const route_obj = {
					name: 'lpo',
					params: {
						lpo_id: lpo.lpo_id,
					}
				};
				this.$router.push(route_obj);
			},

			lpoIsSelected(lpo) {
				return this.selectedLpo && (this.selectedLpo.lpo_id === lpo.lpo_id);
			},

			lpoInGroup(lpo) {
				if (!this.selectedLpo) {
					return;
				}

				if (this.selectedLpo.lease_id === null) {
					return false;
				}

				if (this.selectedLpo.lpo_id === lpo.lpo_id) {
					return false;
				}

				return this.selectedLpo && this.selectedLpo.lease_id === lpo.lease_id;
			},

			normalizeDate(lpo) {
				if (!lpo || !lpo.inspection_date) {
					return;
				}

				const date = lpo.inspection_date;
				return date.split('-').reverse().join('.');
			}
		}
	};
</script>

<style scoped>


	tr.selected td {
		background-color: lightblue;
	}


	/* TABLE */

	.table-container {

/*		height: calc(100vh - (44px + 44px + 1px));*/
		flex: 1;
		overflow-y: scroll;

	}

	.table-lpo-list {
		border-collapse: separate;
		border-spacing: 0;
		font-size: 0.8rem;
		text-align: center;
		
		width: 100%;
	}
	.table-lpo-list th,
	.table-lpo-list td {
		border-bottom: 1px solid #c0c0c0;
		border-left: 1px solid #c0c0c0;

		vertical-align: middle;
	}

	.table-lpo-list th {
		background-color: #034444;
		color: #fff;
		/*font-weight: bold;*/
		/*padding: 12px 2px;*/
		
		position: sticky;
		top: 0;
	}

	.table-lpo-list td {
		cursor: pointer;
		padding: 4px 2px;
	}

	.table-lpo-list tbody tr:nth-child(even) td {
		background-color: #f7f7f7;
	}

	.table-lpo-list tbody tr:hover > td {
		background-color: #d8ecf3;
	}
	.table-lpo-list tbody tr.in-group > td
	{
		background-color: #ccefff;
		/*background-color: green;*/
	}
	.table-lpo-list tbody tr.selected > td {
		background-color: #add8e6;
	}
	
	

</style>